import { useState } from 'react';
import {
  fullScreenButtonClick,
  ImageGallery,
  MarketplaceBuyModal,
  MarketplaceSendOfferModal,
  ShareImagesModal,
  ContainerListModal,
} from '../../design-system';
import { MarketplacePage, MarketplaceHeader, MarketplaceBody } from './MarketplaceComponents';
import { RoleGuard } from '../../routes';
import { saleService } from '../../services';

export const Marketplace = () => {
  const [data, setData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [checkIndexs, setCheckIndexs] = useState<number[]>([]);
  const [images, setImages] = useState<any>([]);
  const [containerList, setContainerList] = useState<any>();

  const handleCheckboxChange = (i: number) => {
    if (isNaN(i)) {
      const allCheckIndexs = Array.from({ length: data.length }, (_, i) => i);
      setCheckIndexs(checkIndexs.length === data.length ? [] : allCheckIndexs);
      return;
    }

    setCheckIndexs((prev) =>
      prev.includes(i) ? prev.filter((index) => index !== i) : [...prev, i],
    );
  };

  const handleClickImage = (images: any[], id: string) => {
    saleService.getOneVisit(id);
    setImages(images.map(({ url }) => url));
    fullScreenButtonClick();
  };

  return (
    <RoleGuard
      roles={[
        'SUPER_ADMIN',
        'YARD_COMPANY_ADMIN',
        'YARD_COMPANY_VIEWER',
        'YARD_MANAGER',
        'CLIENT_MANAGER',
        'CLIENT_DISPATCHER',
      ]}
    >
      <MarketplacePage innerScroll>
        <MarketplaceHeader
          totalCount={totalCount}
          containerList={containerList}
          setContainerList={setContainerList}
        />
        <MarketplaceBody
          setData={setData}
          setTotalCount={setTotalCount}
          checkIndexs={checkIndexs}
          setCheckIndexs={setCheckIndexs}
          handleCheckboxChange={handleCheckboxChange}
          handleClickImage={handleClickImage}
          containerList={containerList}
          setContainerList={setContainerList}
        />
      </MarketplacePage>
      <ContainerListModal validContainers />
      <MarketplaceBuyModal />
      <MarketplaceSendOfferModal />
      <ImageGallery photos={images} startIndex={0} />
      <ShareImagesModal />
    </RoleGuard>
  );
};
